// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"cff77fbc","453":"cf33e53c","630":"0ca2e123"}[chunkId] + ".chunk.js";
};